import PropTypes from 'prop-types';

export const RoomsPaxRestrictionProps = PropTypes.shape({
    maxRooms: PropTypes.number.isRequired,
    minAdults: PropTypes.number.isRequired,
    defaultAdults: PropTypes.number.isRequired,
    maxKidsAge: PropTypes.number.isRequired,
    maxPassengers: PropTypes.number,
    maxKidsPerAdult: PropTypes.number,
    maxPassengersPerRoom: PropTypes.number,
    maxChildrenPerAdult: PropTypes.number,
});

export const DpPaxRestrictionPropsDefault = {
    maxRooms: 4,
    minAdults: 1,
    minRooms: 1,
    defaultAdults: 2,
    maxPassengers: 9,
    maxPassengersPerRoom: 4,
    maxKidsPerAdult: 2,
    maxKidsAge: 11,
    maxAdults: 10,
    maxKids: 10,
    minKids: 0,
    maxInfantAge: 1,
    recommendedAdultsPerRoom: 2,
    maxRoomsWithAdults: 3,
};

export const NonPrimeHotelPropsDefault = {
    maxRooms: 8,
    minAdults: 1,
    minRooms: 1,
    defaultAdults: 1,
    maxKidsAge: 17,
    maxAdults: 10,
    maxKids: 10,
    minKids: 0,
};

export const HotelStandalonePaxRestrictionPropsDefault = {
    minRooms: 1,
    maxRooms: 8,
    minAdults: 1,
    defaultAdults: 2,
    maxPassengers: 10,
    maxAdults: 30,
    maxPassengersPerRoom: 10,
    maxKidsPerAdult: 6,
    maxKidsAge: 17,
    hotelSegmentIndex: 0
};
